import { CheckCircle2, AlertTriangle, Info, XCircle } from "lucide-react";
import { cn } from "@/lib/cn";

export type ToastTone = "default" | "success" | "warning" | "danger" | "info";

interface Props { message: string; tone?: ToastTone; }

const icons = {
  default: Info, success: CheckCircle2, warning: AlertTriangle, danger: XCircle, info: Info,
};
const tones: Record<ToastTone, string> = {
  default: "border-border",
  success: "border-success",
  warning: "border-warning",
  danger: "border-danger",
  info: "border-info",
};

export function Toast({ message, tone = "default" }: Props) {
  const Icon = icons[tone];
  return (
    <div
      role="status"
      className={cn(
        "flex items-start gap-2 px-3 py-2 bg-bg-elevated border rounded-lg shadow-sm text-sm min-w-64",
        tones[tone],
      )}
    >
      <Icon className="size-4 mt-0.5 text-text-muted" />
      <span>{message}</span>
    </div>
  );
}
